import { translationMixin } from '@elements/translation';

export const actionsMixins = {
  mixins: [ translationMixin ],
  props: {
    deal: { type: Object, required: true },
  },
};
